module.exports = __webpack_public_path__ + "media/src/images/icons/organization-afa4399e9707f7d9f13f73bbfe5407bd.svg";